import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  deleteStockReconcillation,
  getStockReconcillation,
} from '../../network/stockReconcillation';
import { deleteStockEntry, getStockEntry } from '../../network/stockEntry';
import {
  deleteLandedCostVoucher,
  getLandedCostVoucher,
} from '../../network/landedCostVoucher';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import {
  deleteEmployeeAdvance,
  getEmployeeAdvance,
} from '../../network/employeeAdvance';
import {
  deleteAdditionalSalay,
  getAdditionalSalay,
} from '../../network/additionalSalay';
import {
  deleteDepartmentHr,
  getDepartmentHr,
} from '../../network/departmentHr';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const DepartmentHr = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteDepartmentHr(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getDepartmentHr] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getDepartmentHr],
    queryFn: () => getDepartmentHr(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.paymentEntry,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/department-hr/edit/${record?.name}`);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.deleteDepartment + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.paymentEntry}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.parentDepartment,
      dataIndex: 'parent_department',
      key: 'parent_department',
    },
    {
      title: t.disabled,
      dataIndex: 'disabled',
      key: 'disabled',
      render: (text, record) => (
        <StatusTag status={record?.disabled === 1 ? 'Yes' : 'No'} />
      ),
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button size="small" type="primary"
              onClick={() => {
                navigate(`/department-hr/edit/${record?.name}`)
              }}
              icon={<MdModeEditOutline />}
              />
            <Popconfirm
              title={t.deleteDepartment + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger 
              icon={<MdDelete />}
              />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.HR} subTitle={t.department} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/department-hr/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addDepartment}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default DepartmentHr;
